import { DIVISIONS } from '@multirx/shared/types/division.js';
import type { SeasonCampaignDetail } from '@multirx/shared/types/championship.js';
import { appendDivisionCardProfileShell } from '../championship/championshipDivisionCard.js';
import { createPillButton } from '../ui/pillButton.js';
import { formatCampaignDateFr } from './seasonHistoryModel.js';
import { campaignDivisionToActiveView } from './campaignToActiveView.js';

export type HistoricSeasonPanelHandlers = {
  onBackToActive: () => void;
};

/** Panneau championnat en lecture seule pour une campagne passée. */
export function renderHistoricSeasonPanel(
  host: HTMLElement,
  detail: SeasonCampaignDetail,
  handlers: HistoricSeasonPanelHandlers
): void {
  host.innerHTML = '';
  host.className = 'seasons-championship-host';

  const panel = document.createElement('div');
  panel.className = 'dashboard-panel dashboard-panel--championship';
  panel.id = 'seasons-championship-heading';

  const head = document.createElement('div');
  head.className = 'championship-panel-head';

  const title = document.createElement('h2');
  title.textContent = formatCampaignDateFr(detail.startedAt);

  const status = document.createElement('p');
  status.className = 'championship-status-line';
  status.textContent =
    detail.status === 'completed'
      ? `Saison terminée — ${detail.meetingCount} meetings joués.`
      : `Meeting ${detail.currentMeetingIndex} / ${detail.meetingCount}.`;

  const backBtn = createPillButton('Retour à la saison', {
    variant: 'soft',
    small: true,
    class: 'championship-history-btn championship-history-btn--back',
    onClick: handlers.onBackToActive,
  });

  head.append(title, status, backBtn);
  panel.appendChild(head);

  const stack = document.createElement('div');
  stack.className = 'championship-divisions-stack';

  for (const division of DIVISIONS) {
    const divDetail = detail.divisions.find((d) => d.division === division.id);
    if (!divDetail) continue;
    const view = campaignDivisionToActiveView(detail, divDetail);
    const card = document.createElement('div');
    card.className = 'championship-division-card';
    card.dataset.division = String(division.id);
    const circuitName = view.currentMeeting?.circuitName?.trim();
    appendDivisionCardProfileShell(card, view, {
      division: division.id,
      divisionLabel: `Division ${division.id}`,
      circuitLine: circuitName || null,
      meetingLine: `Meeting ${detail.currentMeetingIndex} / ${detail.meetingCount}`,
      sessionLine: detail.status === 'completed' ? 'Division terminée.' : null,
    });
    stack.appendChild(card);
  }

  panel.appendChild(stack);
  host.appendChild(panel);
}
